/**
 * http配置
 */
import axios from 'axios'
import store from '@/store'
import {getToken} from '@/utils/cookie'
import {Message} from 'element-ui'
import {generateCode} from '@/utils/i18n'
import errorCode from '@/utils/errorCode'
// 进度条
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import {business} from '@/api/common'
// progress bar style
NProgress.configure({showSpinner: false})// NProgress Configuration

// 超时时间
axios.defaults.timeout = 60000
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true
// const permiss = ['/portal/']
/**
 * HTTP request拦截
 */
axios.interceptors.request.use(config => {
  if (!config.headers.NotShowProgress) {
    NProgress.start() // start progress bar
  }
  if (!(config.headers.NotNeedAuthorization)) {
    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带token--['Token']为自定义key 请根据实际情况自行修改
    }
  }
  if (config.url.indexOf(business) > -1) {
    config.headers['tenant-code'] = store.state.login.tenantInfo.tenantCode || '0'
  }
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * HTTP response拦截
 */
axios.interceptors.response.use(data => {
  NProgress.done()
  // 判断token是否即将过期
  if (data.headers['refresh-token-header']) {
    store.commit('REFRESH_TOKEN')
  }
  if (!data.data.code) {
    return data
  }
  if (data.data.code === errorCode.SUCCESS.code) {
    return data
  } else {
    // 后台token已丢失
    if (data.data.code === errorCode.ACCESSTOKEN_INVALID.code) {
      window.vm.$alert(data.data.msg, '提示', {
        confirmButtonText: '确定',
        showClose: false,
        callback: action => {
          window.vm.$store.dispatch('LogOut').then(() => {
            const projectName = 'research-pc'
            window.location.href = `${window.location.protocol}//${window.location.host}/${projectName}/`
          })
        }
      })
    } else {
      // 判断是否需要错误提示
      if (!data.config.headers['NotNeedErrorMessage']) {
        Message({
          message: data.data.msg || generateCode(data.data.code) || generateCode('default'),
          type: 'error',
          showClose: true
        })
      }
      return data
    }
  }
}, error => {
  console.info(error)
  NProgress.done()
  let data = error.response.data
  let message = data.msg
  Message({
    message: message || generateCode('default'),
    type: 'error'
  })
  return Promise.reject(new Error(error))
})

export default axios



// WEBPACK FOOTER //
// ./src/utils/axios/index.js